import { LitElement, css, html } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import { unsafeHTML } from "lit/directives/unsafe-html.js";

import { getIllustrationVisual } from "../../data/visuals";

import type { PropertyValues } from "lit";
import type { IllustrationVisualData } from "../../types.d";

@customElement("bp-viz-illustration")
export class VizIllustration extends LitElement {
  static styles = css`
    :host {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
    }

    figure {
      margin: var(--size-2) 0;
    }

    img {
      max-width: 100%;
    }

    bp-caption {
      align-self: flex-start;
      margin-top: var(--size-1);
      overflow-wrap: anywhere;
    }
  `;

  @property({ attribute: "arc-id" })
  arcId?: string;

  @state()
  data?: IllustrationVisualData;

  updated(changedProperties: PropertyValues) {
    if (!changedProperties.has("arcId") || !this.arcId) return;

    getIllustrationVisual(this.arcId)
      .then(({ data }) => {
        this.data = data;
      })
      .catch(() => undefined);
  }

  render() {
    if (!this.data) return;

    const { src, alt, caption } = this.data;

    return html`
      <figure>
        <img src=${src} alt=${alt} title=${alt} />

        ${caption && html`<bp-caption>${unsafeHTML(caption)}</bp-caption>`}
      </figure>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "bp-viz-illustration": VizIllustration;
  }
}
